// extracted by mini-css-extract-plugin
export default {"dropdown":"ShareDropdown_dropdown__f8Cx+","title":"ShareDropdown_title__poNgm","socials":"ShareDropdown_socials__FeIOr","social":"ShareDropdown_social__n9LoN"};